$( document ).ready(function() {

    /*******************************************************************************
     *  Site Header Scroll Behavior
     ******************************************************************************/

    var scrollPos = 0;
    var scrollPosTop = 0;
    var scrollPosBottom = 0;

    document.addEventListener("scroll", (event) => {

        if(window.scrollY < 120) {
            showFullHeader();
            hideHeaderShadow();
            scrollPosTop = window.scrollY;
            scrollPosBottom = window.scrollY;
        } else {
            showHeaderShadow();
            if(scrollPos < window.scrollY) {
                // User is scrolling down

                if(
                    // User has to scroll down 100 pixels to trigger
                    scrollPosBottom <= window.scrollY
                    && window.scrollY - scrollPosBottom > 100
                ) {
                    showScrollHeader();
                }

                scrollPosTop = window.scrollY;
            } else {
                // User is scrolling up

                if(
                    // User has to scroll up 200 pixels to trigger
                    scrollPosTop >= window.scrollY
                    && scrollPosTop - window.scrollY > 200
                ) {
                    showFullHeader();
                }

                scrollPosBottom = window.scrollY;
            }
        }

        scrollPos = window.scrollY;
    });

    function showFullHeader() {
        if($('#topnavbar').hasClass('scrolled')) {
            $('#topnavbar').removeClass('scrolled');
        }
    }

    function showScrollHeader() {
        if(!$('#topnavbar').hasClass('scrolled')) {
            $('#topnavbar').addClass('scrolled');
        }
    }

    function showHeaderShadow() {
        if(!$('#topnavbar').hasClass('header_shadow')) {
            $('#topnavbar').addClass('header_shadow');
        }
    }

    function hideHeaderShadow() {
        if($('#topnavbar').hasClass('header_shadow')) {
            $('#topnavbar').removeClass('header_shadow');

            // Check if quickmenu toggler is still shown
            if($('#quickmenu-toggler').hasClass('show')) {
                $('#quickmenu-toggler').collapse('hide');
            }
        }
    }

    /*******************************************************************************
     *  KeSearch Form Handling
     ******************************************************************************/

    $('form[name="form_kesearch_pi1"]').on('submit', function(e) {
        e.preventDefault();
        let data = $( this ).serializeArray();
        let searchWord = '';
        data.forEach( (element) => {
            if( element.name == 'tx_kesearch_pi1[sword]') {
                searchWord = element.value;
            }

            if( element.name == 'tx_kesearch_pi1[searchActionUrl]') {
                if( element.value == 'catalog' ) {
                    // catalog search was selected
                    let url = $(this).data('action-catalog').split('|');
                    if( searchWord && url ) {
                        window.location.href = url[0] + searchWord + url[1];
                    }
                } else {
                    // default is website search
                    $( this ).unbind( 'submit' ).submit();
                }
            }
        });
    });

    /*******************************************************************************
     *  Accordion URL Hash Update
     ******************************************************************************/

    const accordionCollapses = document.querySelectorAll('.accordion-collapse');

    function updateUrlHash(id) {
        history.replaceState(null, '', '#' + id);
    }

    function removeUrlHash() {
        history.replaceState(
            null,
            '',
            window.location.pathname + window.location.search
        );
    }

    accordionCollapses.forEach((el) => {
        el.addEventListener('shown.bs.collapse', function () {
            if (this.id) {
                updateUrlHash(this.id);

                // timeout after collapse
                setTimeout(function() {
                  const header = el.parentNode.querySelector('.accordion-header');

                  // check if accordion item header is visible ( in viewport )
                  if( !isElementInViewport(header) ) {
                    // if not - scroll to accordion item header
                    window.scroll({ top: (header.offsetTop - 200), left: 0, behavior: 'smooth' });
                  }
                }, 100)

            }
        });

        el.addEventListener('hidden.bs.collapse', function () {
            if (window.location.hash === '#' + this.id) {
                removeUrlHash();
            }
        });
    });
    function isElementInViewport (el) {
        var rect = el.getBoundingClientRect();

        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    /*******************************************************************************
     *  set table-fixed class to small tables
     ******************************************************************************/

    if($('table').length) {
        $('table').each(function() {
           if($(this).children('tbody').children(':first').children().length <= 3) {
                $(this).addClass('table-fixed');
           }
        });
    }

    /*******************************************************************************
     *  fix browser form validations not shown after scroll effect
     ******************************************************************************/

    var forms = document.querySelectorAll('form');
    forms.forEach(singleForm => forceValidationErrorDisplay(singleForm));

    function forceValidationErrorDisplay(form) {
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.addEventListener('click', function (event) {
                if (form.checkValidity()) return;

                const firstInvalidField = form.querySelector(':invalid');
                if (firstInvalidField && !isElementInViewport(firstInvalidField)) {
                    event.preventDefault();
                    firstInvalidField.scrollIntoView({behavior: 'smooth', block: 'start'});
                    firstInvalidField.focus();
                    setTimeout(function () {
                        firstInvalidField.reportValidity();
                    }, 750);
                }
            });
        }
    }

  /*******************************************************************************
   *  Contrast Button
   ******************************************************************************/

    $('#toggle-contrast').on('click', function(e) {
        e.preventDefault();

        if($('html').attr('data-bs-theme') === 'dark') {
            $('html').attr('data-bs-theme', 'light');
            document.cookie = "contrast=light; path=/; max-age=31536000"; // 1 year
        } else {
            $('html').attr('data-bs-theme', 'dark');
            document.cookie = "contrast=dark; path=/; max-age=31536000"; // 1 year
        }
    });

    $('#toggle-contrast-mobile').on('click', function(e) {
        e.preventDefault();

        if($('html').attr('data-bs-theme') === 'dark') {
            $('html').attr('data-bs-theme', 'light');
            document.cookie = "contrast=light; path=/; max-age=31536000"; // 1 year
        } else {
            $('html').attr('data-bs-theme', 'dark');
            document.cookie = "contrast=dark; path=/; max-age=31536000"; // 1 year
        }
    });

    let contrastCookie = document.cookie.split('; ').find(row => row.startsWith('contrast='));
    if(contrastCookie) {
        contrastCookie = contrastCookie.split('=')[1];
        $('html').attr('data-bs-theme', contrastCookie);
    }

    /*******************************************************************************
     *  Form JS
     ******************************************************************************/

    if($('#antragaufBibliotheksausweisverlaengerung-1263-radiobutton-4-0').length) {
      $('#antragaufBibliotheksausweisverlaengerung-1263-radiobutton-4-0').on('change', function() {
        if($(this)[0].checked) {
          $('#antragaufBibliotheksausweisverlaengerung-1263-text-5').removeAttr('required');
          $('#antragaufBibliotheksausweisverlaengerung-1263-text-6').removeAttr('required');
          $('#antragaufBibliotheksausweisverlaengerung-1263-text-7').removeAttr('required');
        }
      });

      $('#antragaufBibliotheksausweisverlaengerung-1263-radiobutton-4-1').on('change', function() {
        if($(this)[0].checked) {
          $('#antragaufBibliotheksausweisverlaengerung-1263-text-5').prop('required', 'true');
          $('#antragaufBibliotheksausweisverlaengerung-1263-text-6').prop('required', 'true');
          $('#antragaufBibliotheksausweisverlaengerung-1263-text-7').prop('required', 'true');
        }
      });
    }

    /*******************************************************************************
     *  Disable click on edit cookies button
     ******************************************************************************/
    $('#editCookies').on('click', function(e) {
        e.preventDefault();
    });
});
